(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .factory('workqueueService', workqueueService);

  /* ngInject */
  function workqueueService($resource, config) {
    let url = `${config.complianceServicesApiEndpoint}/api/workqueue/:id`;
    let paramDefaults = {id: '@id'};
    let headers = authToken => ({'Authorization': 'Token token=' + authToken});
    let actions = authToken => ({
      'query': {
        method: 'GET', 
        isArray: false, 
        params: { page: `@page`, selected_staffer: `@selected_staffer` },
        headers: headers(authToken)
      },
      'show': {
        method: 'GET',
        headers: headers(authToken)
      },
      'getStaff': {
        method: 'GET',
        isArray: true,
        headers: headers(authToken),
        url: `${config.complianceServicesApiEndpoint}/api/workqueue/staff`
      },
      'update': {method: 'PUT', headers: headers(authToken)},
      'save': {
        method: 'POST',
        headers: headers(authToken),
        url: `${config.complianceServicesApiEndpoint}/api/workqueue/:id/messages`
      },
      'publishDraft': {
        method: 'PUT', 
        url: `${config.complianceServicesApiEndpoint}/api/workqueue/:id/publish_draft`,
        headers: headers(authToken)
      },
      'updateDraft': {
        method: 'PUT',
        url: `${config.complianceServicesApiEndpoint}/api/workqueue/:id/update_draft`,
        headers: headers(authToken)
      },
      'downloadAttachment': {
        method: 'GET',
        url: `${config.complianceServicesApiEndpoint}/api/messages/:id/attachments/:attachmentId`,
        headers: headers(authToken),
        transformResponse: (data, _headersGetter) => {
          return {content: data};
        }
      },
      'search': {
        method: 'GET',
        isArray: false,
        url: `${config.complianceServicesApiEndpoint}/api/workqueue/search`,
        headers: headers(authToken)
      },
      'counts': {
        method: 'GET',
        isArray: false,
        url: `${config.complianceServicesApiEndpoint}/api/workqueue/counts`,
        headers: headers(authToken)
      },
      'deleteAttachment': {
        method: 'DELETE',
        headers: headers(authToken),
        url: `${config.complianceServicesApiEndpoint}/api/workqueue/:id/messages/:message_id/attachments/:attachment_id`,
        params: {id: '@id', message_id: '@message_id', attachment_id: '@attachment_id'}
      }
    });

    return authToken => $resource(url, paramDefaults, actions(authToken));
  }
})();
